import { format } from 'date-fns'
import { useFormContext } from 'react-hook-form'
import {
  honorificPersonInChargeTitles,
  honorificTitles
} from 'src/hooks/invoice/useInvoices'
import { splitStringByLength } from 'src/utils/StringUtil'
import { InvoiceFormInputs } from '../InvoiceEditForm'
import { INVOICE_PREVIEW_COLS_AT_ROW } from '../InvoiceRemarks'

export const ClientPart: React.FC = () => {
  const { watch } = useFormContext<InvoiceFormInputs>()
  const client = watch('client')
  const title = watch('title')
  const payment_deadline = watch('payment_deadline')
  const clientInfo = [
    client.department_name,
    client.person_in_charge && client.person_in_charge !== '' ? (
      <>
        {client.person_in_charge}
        {honorificPersonInChargeTitles.find(
          (title) => title.value === client.person_in_charge_honorific
        )?.labelOnPreview || ''}
      </>
    ) : undefined
  ].filter((value) => value && value !== '')
  const titleInfo = splitStringByLength(
    `件名：${title}`,
    INVOICE_PREVIEW_COLS_AT_ROW
  ).concat([
    `お支払い期限：
  ${
    payment_deadline ? format(new Date(payment_deadline), 'yyyy年MM月dd日') : ''
  }`
  ])
  return (
    <>
      <text x={36} y={100} fill="#0D0D0D" fontSize={'11px'} fontWeight={'bold'}>
        {client.name}
        {honorificTitles.find((title) => title.value === client.honorific)
          ?.labelOnPreview || ''}
      </text>
      {[clientInfo, titleInfo].map((part, i, arr) =>
        part.map((value, j) => (
          <text
            key={`${i}-${j}`}
            y={
              114 +
              8 * i +
              14 *
                (arr
                  .slice(0, Math.max(i, 0))
                  .reduce((prev, curr) => prev + curr.length, 0) +
                  j)
            }
            x={36}
            fill="#0D0D0D"
            fontSize={'10px'}
          >
            {value}
          </text>
        ))
      )}
    </>
  )
}
